import PropTypes from 'prop-types';
import React from 'react';

import Formsy from 'formsy-react';
import { kebabCase } from 'lodash';
import { Row, Col, Button, Label, FormGroup, SheetFooter, Tabs, TabsList, TabsTrigger, TabsContent, SheetBody, Textarea } from 'twyne-new.ui';

import { useGlobalStore } from '@Stores/global';
import CustomFields from 'components/custom_fields/CustomFields';
import Input from 'components/form/Input';
import appStore from 'stores/app';

class TagForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      site_id: appStore.site.id,
      slugTouch: false,
      custom: {},
      activeTab: 'general',
    };
  }

  toggleTab = tab => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  componentWillReceiveProps({ data }) {
    this.setState(data)
  }

  componentWillMount() {
    const { data } = this.props;
    if (data) {
      if (data.id) {
        data.slugTouch = true
      }

      this.setState(data);
    }
  }

  handleValidSubmit = model => {
    this.props.onSubmit(Object.assign(this.state, model));
  }

  onChangeName = event => {
    const { value } = event.currentTarget;

    if (!this.state.slugTouch) {
      this.setState({
        slug: kebabCase(value),
      });
    }
  }

  onChangeSlug = event => {
    const { value } = event.currentTarget;
    if (value && value.length) {
      this.setState({
        slugTouch: true,
      })
    } else {
      this.setState({
        slugTouch: false,
      })
    }
  }

  Tabs = () => {
    const customFields = this.useCustomFields()

    if (!customFields) {
      return null
    }

    return <TabsList>
      <TabsTrigger className='pt-0!' value='general'>General</TabsTrigger>
      <TabsTrigger className='pt-0!' value='customFields'>Custom Fields</TabsTrigger>
    </TabsList>
  }

  General = () => <Row>
    <Col size='12'>
      <FormGroup>
        <Label>Name</Label>
        <Input name="name" value={this.state.name} onChange={this.onChangeName} required />
      </FormGroup>
    </Col>
    <Col size='12'>
      <FormGroup>
        <Label>Slug</Label>
        <Input name="slug" value={this.state.slug} onChange={this.onChangeSlug} required />
      </FormGroup>
    </Col>
    <Col size='12'>
      <FormGroup>
        <Label>Description</Label>
        <Input name="description" value={this.state.description} component={Textarea} type='textarea' />
      </FormGroup>
    </Col>
  </Row>

  CustomFields = () => {
    const customFields = this.useCustomFields()

    if (!customFields) {
      return null
    }

    return <Row>
      <Col size='12'>
        <CustomFields
          config={customFields}
          onChange={this.handleCustomChange}
          custom={this.state.custom}
        />
      </Col>
    </Row>
  }

  render() {
    return (
      <Formsy onValidSubmit={this.handleValidSubmit} ref="tagForm">
        <SheetBody>
          <Tabs defaultValue='general'>
            <this.Tabs />
            <TabsContent value='general'>
              <this.General />
            </TabsContent>
            <TabsContent value='customFields'>
              <this.CustomFields />
            </TabsContent>
          </Tabs>
        </SheetBody>
        <SheetFooter>
          <this.DeleteButton />
          <Button type="submit" color="accent">Save</Button>
        </SheetFooter>
      </Formsy>
    );
  }

  DeleteButton = () => {
    if (this.props.data && this.props.data.id) {
      return <Button onClick={() => this.props.onDelete(this.state)} variant='outline' color="danger" >Delete</Button>
    } else {
      return null;
    }
  }

  handleCustomChange = (key, value) => {
    const custom = { ...this.state.custom };
    custom[key] = value;
    this.setState({ custom, haveCustomField: true });
  };

  useCustomFields = () => {
    const { siteSettings: { useThemeConfig } } = useGlobalStore()
    return useThemeConfig(`types.${this.props.contentType}.tag.custom`)
  }
}

TagForm.propTypes = {
  onSubmit: PropTypes.func,
  data: PropTypes.any,
  onDelete: PropTypes.func,
  contentType: PropTypes.string,
};

export default TagForm;
